import React, { useEffect } from "react";

const PHOTO_URL =
  "https://customer-assets.emergentagent.com/job_reputation-legal/artifacts/jqxqjt0a_Rechtsanwalt%20Sindros.png";

const qualifikationen = [
  "Zugelassener Rechtsanwalt, spezialisiert auf Internetrecht",
  "Über 14 Jahre Berufserfahrung im Reputationsrecht",
  "Leitung der Rechtsabteilung bei THE PUMA GROUP IKE",
  "Registrierter EU-Experte bei der Europäischen Kommission",
  "Unterzeichner des EU AI Pact",
  "Expertise in DSA, europäischem Medienrecht und Plattformregulierung",
  "Über 250.000 erfolgreich durchgeführte Bewertungslöschungen",
];

export default function UeberMich() {
  useEffect(() => {
    document.title =
      "Über Rechtsanwalt Sindros – 14 Jahre Erfahrung im Internetrecht";
    const meta = document.querySelector('meta[name="description"]');
    if (meta)
      meta.setAttribute(
        "content",
        "Seit 2012 im Internetrecht tätig. RA Sindros leitet die Rechtsabteilung der THE PUMA GROUP. Über 250.000 Bewertungslöschungen."
      );
  }, []);

  return (
    <div>
      {/* Hero with Photo */}
      <section className="bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20 lg:py-28">
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-16 items-start">
            <div className="lg:col-span-2">
              <img
                src={PHOTO_URL}
                alt="Rechtsanwalt Sindros"
                className="w-full max-w-sm rounded-lg shadow-lg object-cover"
                style={{ aspectRatio: "4/5" }}
              />
            </div>
            <div className="lg:col-span-3">
              <h1
                className="text-4xl lg:text-5xl font-bold mb-4"
                style={{
                  color: "#1B3A5C",
                  fontFamily: "'Source Serif 4', serif",
                }}
              >
                Rechtsanwalt Sindros
              </h1>
              <p className="text-lg" style={{ color: "#555555" }}>
                Gründer und Leitung der Rechtsabteilung bei THE PUMA GROUP
              </p>
              <p className="text-lg mt-1" style={{ color: "#2E75B6" }}>
                Spezialisiert auf Internetrecht und Reputationsmanagement
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Mein Werdegang */}
      <section className="bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 pb-20 lg:pb-28">
          <div className="max-w-3xl">
            <h2
              className="text-3xl font-bold mb-8"
              style={{
                color: "#1B3A5C",
                fontFamily: "'Source Serif 4', serif",
              }}
            >
              Mein Werdegang
            </h2>
            <div className="space-y-6" style={{ color: "#555555" }}>
              <p className="text-base leading-relaxed">
                Seit 2012 bin ich als Rechtsanwalt im Bereich Internetrecht und
                Online-Reputationsmanagement tätig. Meine Karriere begann mit der
                rechtlichen Betreuung internationaler Hotels in Griechenland, die
                unter unfairen Bewertungen auf Booking.com und TripAdvisor litten.
              </p>
              <p className="text-base leading-relaxed">
                Die Erfahrung zeigte mir, wie existenzbedrohend ungerechtfertigte
                Online-Bewertungen für Unternehmen sein können – und wie wenig
                rechtliche Möglichkeiten vielen Betroffenen bekannt sind.
              </p>
              <p className="text-base leading-relaxed">
                Ab 2015 weitete ich meine Tätigkeit auf alle großen
                Bewertungsplattformen aus: Google, Trustpilot, Kununu, Jameda und
                viele weitere. Heute leite ich die Rechtsabteilung der THE PUMA
                GROUP, einem auf KI und Digitalisierung spezialisierten
                Technologieunternehmen mit Sitz in Thessaloniki.
              </p>
              <p className="text-base leading-relaxed">
                In Zusammenarbeit mit einem Team aus über 10 Juristen,
                IT-Spezialisten und Reputationsmanagern haben wir bisher über
                250.000 Bewertungen erfolgreich entfernen lassen – mit einer
                Erfolgsquote von 96 %.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Qualifikationen */}
      <section style={{ backgroundColor: "#F5F5F5" }}>
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20 lg:py-28">
          <div className="max-w-3xl">
            <h2
              className="text-3xl font-bold mb-10"
              style={{
                color: "#1B3A5C",
                fontFamily: "'Source Serif 4', serif",
              }}
            >
              Qualifikationen
            </h2>
            <ul className="space-y-4">
              {qualifikationen.map((item, index) => (
                <li
                  key={index}
                  className="text-base leading-relaxed relative pl-6"
                  style={{ color: "#555555" }}
                >
                  <span
                    className="absolute left-0 top-[10px] w-1.5 h-1.5 rounded-full"
                    style={{ backgroundColor: "#2E75B6" }}
                  />
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* THE PUMA GROUP */}
      <section className="bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20 lg:py-28">
          <div className="max-w-3xl">
            <h2
              className="text-3xl font-bold mb-8"
              style={{
                color: "#1B3A5C",
                fontFamily: "'Source Serif 4', serif",
              }}
            >
              THE PUMA GROUP
            </h2>
            <div className="space-y-6" style={{ color: "#555555" }}>
              <p className="text-base leading-relaxed">
                Die THE PUMA GROUP IKE ist ein auf KI und Digitalisierung
                spezialisiertes Technologieunternehmen mit Sitz in Thessaloniki,
                Griechenland. Als registrierter EU-Experte bei der Europäischen
                Kommission und Unterzeichner des EU AI Pact entwickelt das
                Unternehmen KI-gestützte Lösungen für den öffentlichen Sektor und
                die Privatwirtschaft.
              </p>
              <p className="text-base leading-relaxed">
                Fairebewertungen.de ist der spezialisierte Service der THE PUMA
                GROUP für die Löschung unfairer Online-Bewertungen im
                deutschsprachigen Raum.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
